import axios from "axios";
import { UpdateUserMetadataResponse, UpdateUserMetadataRequest } from "redmond";
import { userMetadataPath } from "../paths";
import { config } from "../../config";

export const updateUserMetadata = async (
  body: UpdateUserMetadataRequest
): Promise<UpdateUserMetadataResponse> => {
  const res = await axios.put(userMetadataPath, body, {
    baseURL: config.baseURL,
  });

  return res.data;
};
